










































































































































































import { Component, Vue } from "vue-property-decorator";
import AppIconTextButton from "@/components/_shared/buttons/app-icon-text-button.vue";
import AddressFormComponent from "@/components/_shared/forms/address-form-component.vue";
import { Reception } from "@/interfaces/reception";
import { receptionApiProvider } from "@/providers/reception-api-provider";
import ReceptionSelectedStockGrid from "@/components/reception/reception-selected-stock-grid.vue";
import ContactSearchComponent from "@/components/_shared/searchs/contact-search-component.vue";
import router from "@/router/router";
import { Stock } from "@/interfaces/stock";
import {DocumentOrigin} from "@/interfaces/document";
import DocumentDetailList from "@/components/document/document-detail-list.vue";
import {User} from "@/interfaces/user";
import store from "@/stores/store";
import {AppScope} from "@/utils/app-scope";

@Component({
  name: "reception-list-page",
  computed: {
    DocumentOrigin() {
      return DocumentOrigin
    }
  },
  components: {
    ReceptionSelectedStockGrid,
    AppIconTextButton,
    AddressFormComponent,
    ContactSearchComponent,
    DocumentDetailList
  },
})
export default class ReceptionDetailPage extends Vue {
  reception: Reception | null = null;

  user: User = store.getters["user/getUser"];
  hasScopeRemovalDartess = this.user.scope.find(s => s === AppScope.removalDartess);

  async beforeMount() {
    this.reception = await receptionApiProvider.getReception(this.$route.params.reception_id);
    if (this.reception) {
      const title = this.$t("reception.detail_page_title", { code: this.reception.reference });
      this.$eventHub.$emit("update-title", title);
      this.breadcrumbs.push({ text: title });
    } else {
      await router.push("/404");
    }
  }
  mounted() {
    this.$eventHub.$on("remove-stock-from-cart", (stock: Stock) => {
      this.reception.stocks = this.reception.stocks.filter((s) => s.id !== stock.id);
    });
  }
  beforeDestroy() {
    this.$eventHub.$off("remove-stock-from-cart");
  }
  breadcrumbs = [
    { text: this.$t("app.title") },
    { text: this.$t("reception.list_page_title"), href: "/reception/list" },
  ];

  $refs: {
    orderDetailModal: HTMLFormElement;
  };
}
